import React from 'react';
import { Formik, Form } from 'formik';
import { getUserFromToken } from 'src/DecodeToken';
import { useSelector } from 'react-redux';
import { AddContainer, Component4, Texts, InputTextComponent, TwoButton, SaveButton, InnerTwoButtons, FooterPart } from './Styles';
import * as Yup from 'yup';

function LoginInfoStep({ innerRef, data, setDoctorProfileData, onBack, onSkip, onNext }) {

    const userId = getUserFromToken();
    const user = useSelector(state => state.auth.user);

    const initialValues = {
        // id: data?.id || '',
        username: data?.username || user?.username || user?.personalInfo?.fullName || '',
        email: data?.email || user?.email || '',
        contactNumber: data?.contactNumber || user?.phone || user?.mobileNumber || '',
        biometric: data?.biometric || '',
        user: data?.user || userId
    };
    const handleSubmit = (values) => {
        console.log('LoginInfo Submitted:', values);
        setDoctorProfileData(prev => ({
            ...prev,
            loginInfo: values
        }));
    };
    const validationSchema = Yup.object().shape({
        username: Yup.string().required('Username is required'),
        email: Yup.string()
            .email('Invalid email format')
            .required('Email is required'),
        contactNumber: Yup.string()
            .matches(/^[0-9]{10}$/, 'Contact number must be 10 digits and contain only numbers')
            .required('Contact number is required'),

    });

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            innerRef={innerRef}
        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                <Form>
                    <AddContainer>
                        <Component4>
                            <Texts>User Name</Texts>
                            <InputTextComponent
                                name="username"
                                placeholder="Enter"
                                variant="outlined"
                                value={values.username}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.username && Boolean(errors.username)}
                                helperText={touched.username && errors.username}
                            />
                        </Component4>
                        <Component4>
                            <Texts>Email</Texts>
                            <InputTextComponent
                                name="email"
                                placeholder="Enter Email"
                                variant="outlined"
                                value={values.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.email && Boolean(errors.email)}
                                helperText={touched.email && errors.email}
                            />
                        </Component4>
                        <Component4>
                            <Texts>Contact Number</Texts>
                            <InputTextComponent
                                name="contactNumber"
                                placeholder="Enter"
                                variant="outlined"
                                value={values.contactNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.contactNumber && Boolean(errors.contactNumber)}
                                helperText={touched.contactNumber && errors.contactNumber}

                            />
                        </Component4>
                        <Component4>
                            <Texts>Biometric</Texts>
                            <InputTextComponent
                                name="biometric"
                                placeholder="Enter"
                                variant="outlined"
                                value={values.biometric}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.biometric && Boolean(errors.biometric)}
                                helperText={touched.biometric && errors.biometric}
                            />
                        </Component4>

                    </AddContainer>




                </Form>
            )}
        </Formik>
    );
}

export default LoginInfoStep;
